import { render, staticRenderFns } from "./editButtonTemplate4.vue?vue&type=template&id=1aebb651"
import script from "./editButtonTemplate4.vue?vue&type=script&lang=js"
export * from "./editButtonTemplate4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports